<template>
  <svg
    width="33"
    height="26"
    viewBox="0 0 33 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="online_icon"
  >
    <g clip-path="url(#clip0_7394_68627)">
      <path
        d="M8.43143 21C7.40999 19.9495 6.59972 18.7022 6.04692 17.3296C5.49412 15.9569 5.20959 14.4857 5.20959 13C5.20959 11.5143 5.49412 10.0431 6.04692 8.67042C6.59972 7.29777 7.40999 6.05057 8.43143 5M23.9877 5C25.0091 6.05057 25.8195 7.29777 26.3723 8.67042C26.9251 10.0431 27.2096 11.5143 27.2096 13C27.2096 14.4857 26.9251 15.9569 26.3723 17.3296C25.8195 18.7022 25.0091 19.9495 23.9877 21"
        stroke="#FF9E48"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
        id="path_second"
      />
      <path
        d="M5.60301 24C4.21013 22.5555 3.10522 20.8405 2.3514 18.9532C1.59759 17.0657 1.20959 15.0429 1.20959 13C1.20959 10.9571 1.59759 8.93421 2.3514 7.04682C3.10522 5.15944 4.21013 3.44454 5.60301 2M26.8161 2C28.209 3.44454 29.3139 5.15944 30.0678 7.04682C30.8216 8.93421 31.2096 10.9571 31.2096 13C31.2096 15.0429 30.8216 17.0657 30.0678 18.9532C29.3139 20.8405 28.209 22.5555 26.8161 24"
        stroke="#FF9E48"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
        id="path_last"
      />
      <path
        d="M11.2601 18C10.61 17.3435 10.0943 16.5639 9.7425 15.706C9.39068 14.8481 9.20959 13.9286 9.20959 13C9.20959 12.0714 9.39068 11.1519 9.7425 10.294C10.0943 9.43603 10.61 8.65655 11.2601 8M21.1591 8C21.8092 8.65655 22.3248 9.43603 22.6767 10.294C23.0285 11.1519 23.2096 12.0714 23.2096 13C23.2096 13.9286 23.0285 14.8481 22.6767 15.706C22.3248 16.5639 21.8092 17.3435 21.1591 18"
        stroke="#FF9E48"
        stroke-width="1.2"
        stroke-linecap="round"
        id="path_first"
        stroke-linejoin="round"
      />
      <path
        d="M18.331 15.1214C18.8936 14.5588 19.2096 13.7956 19.2096 13C19.2096 12.2044 18.8936 11.4412 18.331 10.8786C17.7684 10.316 17.0052 10 16.2096 10C15.414 10 14.6508 10.316 14.0882 10.8786C13.5256 11.4412 13.2096 12.2044 13.2096 13C13.2096 13.7956 13.5256 14.5588 14.0882 15.1214C14.6508 15.684 15.414 16 16.2096 16C17.0052 16 17.7684 15.684 18.331 15.1214Z"
        fill="#FF9E48"
        id="path_circle"
      />
    </g>
    <defs>
      <clipPath id="clip0_7394_68627">
        <rect
          width="32"
          height="26"
          fill="white"
          transform="translate(0.209595)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
